export default __webpack_public_path__ + "static/media/mlodz10.8b19a7c7.jpg";